/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useEffect, useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images
import bgImage from "assets/images/bg-sign-in-basic.jpeg";
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
} from "@mui/material";
import { adminLogin } from "api";
import CircularProgress from "@mui/material/CircularProgress";
import MDAlert from "components/MDAlert";

function Basic() {
  const navigate = useNavigate();
  const isAuthenticated = !!localStorage.getItem("token"); // or your auth check

  const [rememberMe, setRememberMe] = useState(false);

  const [selectedCode, setSelectedCode] = useState("+91");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [userType, setUserType] = useState("employee");
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/fair", { replace: true });
    }
  }, [isAuthenticated]);

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  const handleContinue = () => {
    // console.log("______errorMsg______", errorMsg);
    if (email && password) {
      // localStorage.setItem("token", "dummy_token"); // or real token from API
      // navigate("/dashboard", { replace: true }); // ✅ prevent going back to login
      setIsSubmitted(false);

      adminLoginApi();
    } else {
      setIsSubmitted(true);

      // setErrorMsg("Please enter email and password.");
    }

    // navigate("/dashboard", { replace: true });
  };
  const adminLoginApi = () => {
    var params = {
      email: email,
      password: password,
    };

    setIsLoading(true);
    adminLogin({
      params: params,
    })
      .then((responseJson) => {
        setIsLoading(false);

        if (responseJson) {
          const { token, user } = responseJson.data;

          localStorage.setItem("token", token);
          localStorage.setItem("user", JSON.stringify(user));
          navigate("/fair", { replace: true });
        }
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  return (
    <BasicLayout bgColor="info" image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          // borderRadius="xl"
          coloredShadow="info"
          // mx={2}
          // mt={-3}
          p={3}
          mb={1}
          textAlign="center"
          sx={{
            borderTopLeftRadius: "12px",
            borderTopRightRadius: "12px",
          }}
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Log in to Study Smart
          </MDTypography>

          {/* <Grid container spacing={3} justifyContent="center" sx={{ mt: 1, mb: 2 }}>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <FacebookIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GitHubIcon color="inherit" />
              </MDTypography>
            </Grid>
            <Grid item xs={2}>
              <MDTypography component={MuiLink} href="#" variant="body1" color="white">
                <GoogleIcon color="inherit" />
              </MDTypography>
            </Grid>
          </Grid> */}
        </MDBox>
        {/* <MDBox pt={3} px={3}>
          <FormControl component="fieldset">
            <RadioGroup row name="user-type" value={userType} onChange={handleUserTypeChange}>
              <FormControlLabel
                value="employee"
                control={<Radio color="primary" />}
                label="Employee"
                sx={{ mr: 3 }}
              />
              <FormControlLabel
                value="employer"
                control={<Radio color="primary" />}
                label="Employer"
              />
            </RadioGroup>
          </FormControl>
        </MDBox> */}
        <MDBox pt={3} pb={3} px={3}>
          <MDBox
            component="form"
            role="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleContinue(); // same as your onClick
            }}
          >
            <MDBox mb={2} display="flex" gap={1}>
              {/* <MDInput
                select
                label="Code"
                value={selectedCode}
                onChange={(e) => setSelectedCode(e.target.value)}
                sx={{ minWidth: 80 }}
                InputProps={{ sx: { height: "44px" } }}
              >
                {countryCodes.map((country) => (
                  <MenuItem key={country.code} value={country.code}>
                    {country.label} {country.code}
                  </MenuItem>
                ))}
              </MDInput> */}
              <MDInput
                type="email"
                label={
                  <>
                    Email
                    <span style={{ color: "red" }}>*</span>
                  </>
                }
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                helperText={isSubmitted && !email ? "Email is required" : ""}
                FormHelperTextProps={{
                  sx: {
                    color: "red",
                    marginLeft: "0",
                  },
                }}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label={
                  <>
                    Password
                    <span style={{ color: "red" }}>*</span>
                  </>
                }
                fullWidth
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                helperText={isSubmitted && !password ? "Password is required" : ""}
                FormHelperTextProps={{
                  sx: {
                    color: "red",
                    marginLeft: "0",
                  },
                }}
              />
            </MDBox>
            {/* <MDBox display="flex" alignItems="center" ml={-1}>
              <Switch checked={rememberMe} onChange={handleSetRememberMe} />
              <MDTypography
                variant="button"
                fontWeight="regular"
                color="text"
                onClick={handleSetRememberMe}
                sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
              >
                &nbsp;&nbsp;Remember me
              </MDTypography>
            </MDBox> */}
            <MDBox mt={4} mb={1}>
              <MDButton
                type="submit"
                variant="gradient"
                color="info"
                fullWidth
                onClick={handleContinue}
                disabled={isLoading}
              >
                {isLoading ? <CircularProgress size={24} color="light" /> : "Submit"}
              </MDButton>
            </MDBox>
            {/* <MDBox mt={3} mb={1} textAlign="right">
              <MDTypography variant="button" color="text">
                <MDTypography
                  component={Link}
                  to="/authentication/forgot-password"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Forgot Password?
                </MDTypography>
              </MDTypography>
            </MDBox> */}
          </MDBox>
        </MDBox>
      </Card>
      {/* {errorMsg && (
        <MDAlert
          color="error"
          // dismissible
          // onClose={() => {
          //   console.log("Alert closed");
          //   setErrorMsg("");
          // }}
        >
          {errorMsg}
        </MDAlert>
      )} */}
    </BasicLayout>
  );
}

export default Basic;
